module.exports = __webpack_public_path__ + "media/images/badges/Windows_icon-b8f745b906bc59a37c2740fbd32dc27e.svg";